
import { defineComponent, reactive, watch } from 'vue';
import { Modal } from 'ant-design-vue';
import storeSistema from '@/store/storeSistema';
import Card from '@/core/components/Tela/Card.vue';
import Icone from '@/core/components/Icone.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import RequisicaoModal from '@/core/components/Modal/RequisicaoModal.vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useGradeBase } from '@/core/composables/GradeBase';
import { useModalBase } from '@/core/composables/ModalBase';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { ITelaOperacao } from '@/core/models/ITelaOperacao';
import { IProduto, IProdutoCusto } from '@/models/Entidades/Cadastros/Produtos/IProduto';
import SelecionarCategoria from '@/components/Cadastros/Produtos/SelecionarCategoria.vue';
import SelecionarMarca from '@/components/Cadastros/Produtos/SelecionarMarca.vue';
import SelecionarTipoProduto from '@/components/Cadastros/Produtos/SelecionarTipoProduto.vue';
import SelecionarGenero from '@/components/Cadastros/Produtos/SelecionarGenero.vue';
import SelecionarNcm from '@/components/Cadastros/Produtos/SelecionarNcm.vue';
import SelecionarOrigemMercadoria from '@/components/Cadastros/Tributacoes/CenariosFiscais/SelecionarOrigemMercadoria.vue';
import SelecionarCest from '@/components/Cadastros/Produtos/SelecionarCest.vue';
import SelecionarConceitoPrecificacao from '@/components/Cadastros/Precificacao/TabelasPreco/SelecionarConceitoPrecificacao.vue';
import ServicoProduto from '@/servicos/Cadastros/Produtos/ServicoProduto';
import { ITabelaPrecoItemProduto } from '@/models/Entidades/Cadastros/Precificacao/ITabelaPreco';
import { ITipoPreco } from '@/models/Entidades/Cadastros/Precificacao/ITipoPreco';
import { IDTOTabelaPreco, IDTOTabelaPrecoEstrutura } from '@/models/DTO/Cadastros/Precificacao/IDTOTabelaPreco';
import ProdutoPrecos from '@/components/Cadastros/Produtos/ProdutoPrecos.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import ServicoTabelaPreco from '@/servicos/Cadastros/Precificacao/ServicoTabelaPreco';
import { EFormaInclusaoItens } from '@/models/Enumeradores/Cadastros/Precificacao/EFormaInclusaoItens';
import { ETipoItem } from '@/models/Enumeradores/Compartilhados/ETipoItem';
import { ITipoCusto } from '@/models/Entidades/Cadastros/Precificacao/ITipoCusto';
import ServicoTipoCusto from '@/servicos/Cadastros/Precificacao/ServicoTipoCusto';
import ProdutoCustos from '@/components/Cadastros/Produtos/ProdutoCustos.vue';
import { IDTOProdutoAlteracao } from '@/models/DTO/Cadastros/Produtos/IDTOProdutoAlteracao';
import { IDTOProduto } from '@/models/DTO/Cadastros/Produtos/IDTOProduto';

export default defineComponent({
  name: 'AlteracaoProdutoMassa',
  props: {
    visivel: {
      type: Boolean,
    },
    empresa: {
      type: Number,
      required: true,
    },
    operacao: {
      type: Object as () => ITelaOperacao,
      required: true,
    },
    produtos: {
      type: Object as () => number[],
      required: true,
    },
  },
  emits: ['update:visivel', 'confirmacao'],
  components: {
    Card,
    Icone,
    MensagemSemDados,
    RequisicaoModal,
    SelecionarCategoria,
    SelecionarMarca,
    SelecionarTipoProduto,
    SelecionarGenero,
    SelecionarNcm,
    SelecionarOrigemMercadoria,
    SelecionarCest,
    SelecionarConceitoPrecificacao,
    ProdutoPrecos,
    ProdutoCustos,
  },
  setup(props, { emit }) {
    const { telaBase, apresentarMensagemSucesso } = useTelaBase();
    const { gradeBase } = useGradeBase();
    const {
      modalBase, apresentarRetornoRequisicao, apresentarBarraProgresso, ocultarBarraProgresso,
    } = useModalBase(props, emit);

    const servicoProduto = new ServicoProduto();
    const servicoTipoCusto = new ServicoTipoCusto();

    const state = reactive({
      produtosAlterados: [] as IProduto[],
      codigoCategoria: 0,
      alterouCategoria: false,
      codigoMarca: 0,
      alterouMarca: false,
      codigoTipoProduto: 0,
      alterouTipoProduto: false,
      codigoGenero: '',
      alterouGenero: false,
      codigoNcm: 0,
      alterouNcm: false,
      codigoOrigem: 0,
      alterouOrigem: false,
      codigoCest: '',
      alterouCest: false,
      codigoPrecificacao: 0,
      alterouPrecificacao: false,
      formaAlteracao: 1,
      alterouFormaAlteracao: false,
      custo: 0.0,
      alterouCusto: false,
      custoMedio: 0.0,
      alterouCustoMedio: false,
      precoVenda: 0.0,
      alterouPrecoVenda: false,
      carregandoPrecos: false,
      tiposPrecos: [] as ITipoPreco[],
      tabelasPrecos: [] as IDTOTabelaPreco[],
      tabelaPreco: [] as ITabelaPrecoItemProduto[],
      tiposCustos: [] as ITipoCusto[],
      custoProduto: [] as IProdutoCusto[],
      carregandoCustos: false,
      listaAlteracao: {} as IDTOProdutoAlteracao,
      produtos: [] as IProduto[],
      dtoProduto: [] as IDTOProduto[],
    });

    function preencherColunas() {
      if (gradeBase.layoutMobile) {
        gradeBase.colunas = [
          {
            title: 'Código', dataIndex: 'codigoProduto', key: 'Codigo', visible: false, position: 0,
          },
          {
            title: 'Produto', dataIndex: 'produto', key: 'ProdutoMobile', visible: true, position: 1,
          },
        ];
        return;
      }

      gradeBase.colunas = [
        {
          title: 'Código', dataIndex: 'codigoProduto', key: 'Codigo', visible: false, position: 0,
        },
        {
          title: 'Código Interno', dataIndex: 'codigoInterno', key: 'CodigoInterno', visible: true, position: 1, width: 110, ellipsis: true, fixed: 'left',
        },
        {
          title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', visible: true, position: 2, width: 220, ellipsis: true, fixed: 'left',
        },
        {
          title: 'Categoria', dataIndex: 'categoria', key: 'Categoria', visible: true, position: 3, width: 140, ellipsis: true,
        },
        {
          title: 'Marca', dataIndex: 'marca', key: 'Marca', visible: true, position: 4, width: 140, ellipsis: true,
        },
        {
          title: 'Tipo Produto', dataIndex: 'descricaoTipo', key: 'TipoProduto', visible: true, position: 5, width: 140, ellipsis: true,
        },
        {
          title: 'NCM', dataIndex: 'ncm', key: 'Ncm', visible: true, position: 6, width: 90, ellipsis: true,
        },
        {
          title: 'Origem', dataIndex: 'origem', key: 'Origem', visible: true, position: 7, width: 120, ellipsis: true,
        },
        {
          title: 'CEST', dataIndex: 'cest', key: 'Cest', visible: true, position: 9, width: 90, ellipsis: true,
        },
      ];
    }

    function limparTela() {
      state.produtosAlterados = [];
      state.codigoCategoria = 0;
      state.alterouCategoria = false;
      state.codigoMarca = 0;
      state.alterouMarca = false;
      state.codigoTipoProduto = 0;
      state.alterouTipoProduto = false;
      state.codigoGenero = '';
      state.alterouGenero = false;
      state.codigoNcm = 0;
      state.alterouNcm = false;
      state.codigoOrigem = 0;
      state.alterouOrigem = false;
      state.codigoCest = '';
      state.alterouCest = false;
      state.codigoPrecificacao = 0;
      state.alterouPrecificacao = false;
      state.formaAlteracao = 1;
      state.alterouFormaAlteracao = false;
      state.custo = 0.0;
      state.alterouCusto = false;
      state.custoMedio = 0.0;
      state.alterouCustoMedio = false;
      state.precoVenda = 0.0;
      state.alterouPrecoVenda = false;
    }

    function criarPrecoProdutoDefinicao(estrutura: IDTOTabelaPrecoEstrutura) {
      const precoProduto: ITabelaPrecoItemProduto = {} as ITabelaPrecoItemProduto;
      precoProduto.codigo = 0;
      precoProduto.codigoProdutoDefinicao = 0;
      precoProduto.codigoTabelaPreco = estrutura.codigoTabelaPreco;
      precoProduto.codigoTipoCusto = estrutura.codigoTipoCusto;
      precoProduto.codigoTipoPreco = estrutura.codigoTipoPreco;
      precoProduto.valor = 0;
      precoProduto.markup = estrutura.markupPadrao;
      precoProduto.descontoMaximo = estrutura.descontoMaximoPadrao;
      precoProduto.dataAlteracao = '';

      return precoProduto;
    }

    function criarCustoProdutoDefinicao(codigoTipoCusto:number) {
      const custoProduto:IProdutoCusto = {} as IProdutoCusto;
      custoProduto.codigo = 0;
      custoProduto.codigoProdutoDefinicao = 0;
      custoProduto.codigoTipoCusto = codigoTipoCusto;
      custoProduto.valor = 0;
      custoProduto.dataAtualizacao = '';

      return custoProduto;
    }

    async function preencherTiposCusto() {
      let custosProduto:IProdutoCusto[] = [];
      state.tiposCustos = await servicoTipoCusto.obterTiposCustosPorEmpresaTipoItem([props.empresa], ETipoItem.Produto, true);

      if (UtilitarioGeral.validaLista(state.custoProduto)) {
        custosProduto = UtilitarioGeral.instanciaObjetoLocal(state.custoProduto);
      }
      let criouCustoProduto = false;

      if (UtilitarioGeral.validaLista(state.tiposCustos)) {
        state.tiposCustos.forEach((tipoCustosApresentacao) => {
          custosProduto.push(criarCustoProdutoDefinicao(tipoCustosApresentacao.codigo));
          criouCustoProduto = true;
        });
      }
      if (criouCustoProduto) state.custoProduto = custosProduto;
      state.carregandoCustos = false;
    }

    async function preencherTiposPrecos() {
      const tabelasPrecosApi = await new ServicoTabelaPreco().obterTabelasPrecoEstruturaCompleta([props.empresa], ETipoItem.Produto, true);
      let precosProduto: ITabelaPrecoItemProduto[] = [];

      state.carregandoPrecos = true;

      if (UtilitarioGeral.validaLista(state.tabelaPreco)) {
        precosProduto = UtilitarioGeral.instanciaObjetoLocal(state.tabelaPreco);
      }
      let criouItemPreco = false;

      if (UtilitarioGeral.validaLista(tabelasPrecosApi)) {
        tabelasPrecosApi.forEach((tabelaPreco) => {
          // Adiciona apenas tabelas de preços que tem inclusão novos itens de forma automática
          if (tabelaPreco.formaInclusaoItens === EFormaInclusaoItens.Automatica) {
            state.tabelasPrecos.push(tabelaPreco);

            if (UtilitarioGeral.validaLista(tabelaPreco.estruturas)) {
              tabelaPreco.estruturas.forEach((estrutura) => {
                precosProduto.push(criarPrecoProdutoDefinicao(estrutura));
                criouItemPreco = true;
              });
            }
          }
        });

        if (UtilitarioGeral.validaLista(precosProduto)) {
          const codigosTabelasItens: number[] = [];
          precosProduto.forEach((precoProduto) => {
            if (!codigosTabelasItens.includes(precoProduto.codigoTabelaPreco)) {
              codigosTabelasItens.push(precoProduto.codigoTabelaPreco);
            }
          });
          // Verificação para obter tabelas de preços que podem não ser automáticas
          // ou já adicionadas para o produto que não foi adicionado anteriormente
          codigosTabelasItens.forEach((codigoTabela) => {
            const tabelaPreco = state.tabelasPrecos.find((c) => c.codigo === codigoTabela);
            if (tabelaPreco === undefined) {
              const tabelaPrecoApi = tabelasPrecosApi.find((c) => c.codigo === codigoTabela);
              if (tabelaPrecoApi !== undefined) {
                state.tabelasPrecos.push(tabelaPrecoApi);
              }
            }
          });
        }

        if (state.tabelasPrecos.length > 1) {
          const tiposPrecos: ITipoPreco[] = [];
          state.tabelasPrecos.forEach((tabelaPreco) => {
            tabelaPreco.estruturas.forEach((estrutura) => {
              if (!tiposPrecos.some((c) => c.codigo === estrutura.codigoTipoPreco)) {
                const tipoPreco: ITipoPreco = {} as ITipoPreco;
                tipoPreco.codigo = estrutura.codigoTipoPreco;
                tipoPreco.descricao = estrutura.descricaoTipoPreco;
                tipoPreco.casasDecimais = estrutura.casasDecimaisTipoPreco;
                tiposPrecos.push(tipoPreco);
              }
            });
          });

          state.tiposPrecos = tiposPrecos;
        }
      }
      if (criouItemPreco) { state.tabelaPreco = precosProduto; }
      state.carregandoPrecos = false;
    }

    function montarObjetosAlteracao() {
      for (let i = 0; i < state.produtos.length; i += 1) {
        let produto = {} as IProduto;
        produto = state.produtos[i];
        if (state.alterouCategoria && state.codigoCategoria > 0) {
          for (let j = 0; j < produto.categorias.length; j += 1) {
            produto.categorias[j].codigoCategoriaProduto = state.codigoCategoria;
          }
        }
        if (state.alterouMarca && state.codigoMarca > 0) {
          produto.codigoMarca = state.codigoMarca;
        }
        if (state.alterouTipoProduto && state.codigoTipoProduto > 0) {
          produto.tipoProduto = state.codigoTipoProduto;
        }
        if (state.alterouGenero && state.codigoGenero !== '') {
          produto.genero = state.codigoGenero;
        }

        // Fiscal
        if (state.alterouNcm && state.codigoNcm > 0) {
          produto.codigoNcm = state.codigoNcm;
        }
        if (state.alterouOrigem && state.codigoOrigem > 0) {
          produto.origemMercadoria = state.codigoOrigem;
        }
        if (state.alterouCest && state.codigoCest !== '') {
          produto.codigoCest = state.codigoCest;
        }

        // Precificação
        for (let j = 0; j < produto.definicoes.length; j += 1) {
          const precos = produto.definicoes[j].precos;

          for (let k = 0; k < precos.length; k += 1) {
            const precoProduto = precos[k];

            const tabelaCorrespondente = state.tabelaPreco.find(
              (item) => item.codigoTabelaPreco === precoProduto.codigoTabelaPreco,
            );

            if (tabelaCorrespondente) {
              produto.definicoes[j].precos[k].valor = tabelaCorrespondente.valor;
            }
          }
        }
        for (let j = 0; j < produto.definicoes.length; j += 1) {
          const custos = produto.definicoes[j].custos;

          for (let k = 0; k < custos.length; k += 1) {
            const precoCusto = custos[k];

            const custoCorrespondente = state.tabelaPreco.find(
              (item) => item.codigo === precoCusto.codigo,
            );

            if (custoCorrespondente) {
              produto.definicoes[j].custos[k].valor = custoCorrespondente.valor;
            }
          }
        }
        state.produtosAlterados.push(produto);
      }
      state.listaAlteracao.empresa = props.empresa;
      state.listaAlteracao.produtos = state.produtosAlterados;
    }

    async function alterarProdutos() {
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };

      apresentarBarraProgresso();
      montarObjetosAlteracao();
      retorno = await servicoProduto.alterarEmMassa(state.listaAlteracao);
      ocultarBarraProgresso();

      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        emit('confirmacao');
        apresentarMensagemSucesso(retorno.mensagem);
        limparTela();
        modalBase.computedVisivel = false;
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }

    function confirmarAlteracao() {
      Modal.confirm({
        title: 'Todos os produtos serão alterados com os valores informados. Deseja continuar?',
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        centered: true,
        onOk: async () => {
          await alterarProdutos();
        },
      });
    }

    async function buscarProdutos() {
      for (let i = 0; i < props.produtos.length; i += 1) {
        const produto = await servicoProduto.obter(props.produtos[i], props.empresa);
        state.produtos.push(produto);
      }
      state.listaAlteracao.listaCodigos = [];
      state.listaAlteracao.listaCodigos = props.produtos;
      console.log('listaProdutos ', state.listaAlteracao.listaCodigos);
      state.listaAlteracao.empresa = props.empresa;
      state.dtoProduto = await servicoProduto.obterDTOProdutos(state.listaAlteracao);
    }

    watch(async () => modalBase.computedVisivel, async () => {
      telaBase.carregando = true;
      limparTela();

      if (modalBase.computedVisivel) {
        preencherColunas();
        buscarProdutos();
        preencherTiposPrecos();
        preencherTiposCusto();
      }

      telaBase.carregando = false;
    });

    return {
      telaBase,
      gradeBase,
      modalBase,
      state,
      props,
      confirmarAlteracao,
      storeSistema,
    };
  },
});
